import { TemplateRef } from "@angular/core";
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import { MatDialog } from '@angular/material';
var Superficie_anteproyectoComponent = /** @class */ (function () {
    function Superficie_anteproyectoComponent(fb, dialog) {
        this.fb = fb;
        this.dialog = dialog;
        this.rows = [];
        this.matcher = new FormService();
        this.form = new FormGroup({
            util1: new FormControl(''),
            comun1: new FormControl(''),
            total1: new FormControl(''),
            util2: new FormControl(''),
            comun2: new FormControl(''),
            total2: new FormControl(''),
            util3: new FormControl(''),
            comun3: new FormControl(''),
            total3: new FormControl(''),
            totalt: new FormControl('')
        });
        if (!JSON.parse(localStorage.getItem("superficie_anteproyecto"))) {
            localStorage.setItem("superficie_anteproyecto", JSON.stringify(this.rows));
        }
        else {
            this.rows = JSON.parse(localStorage.getItem("superficie_anteproyecto"));
            this.form.controls['util1'].setValue(this.rows[0] ? this.rows[0].util1 : '');
            this.form.controls['comun1'].setValue(this.rows[0] ? this.rows[0].comun1 : '');
            this.form.controls['total1'].setValue(this.rows[0] ? this.rows[0].total1 : '');
            this.form.controls['util2'].setValue(this.rows[0] ? this.rows[0].util2 : '');
            this.form.controls['comun2'].setValue(this.rows[0] ? this.rows[0].comun2 : '');
            this.form.controls['total2'].setValue(this.rows[0] ? this.rows[0].total2 : '');
            this.form.controls['util3'].setValue(this.rows[0] ? this.rows[0].util3 : '');
            this.form.controls['comun3'].setValue(this.rows[0] ? this.rows[0].comun3 : '');
            this.form.controls['total3'].setValue(this.rows[0] ? this.rows[0].total3 : '');
            this.form.controls['totalt'].setValue(this.rows[0] ? this.rows[0].totalt : '');
        }
        this.superficie_anteproyecto = { util1: '', comun1: '', total1: '', util2: '', comun2: '', total2: '', util3: '', comun3: '', total3: '', totalt: '' };
    }
    Superficie_anteproyectoComponent.prototype.add_superficie_anteproyecto = function () {
        localStorage.setItem("superficie_anteproyecto", JSON.stringify([]));
        this.actualRow = localStorage.getItem("superficie_anteproyecto");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            util1: this.form.value.util1,
            comun1: this.form.value.comun1,
            total1: this.form.value.total1,
            util2: this.form.value.util2,
            comun2: this.form.value.comun2,
            total2: this.form.value.total2,
            util3: this.form.value.util3,
            comun3: this.form.value.comun3,
            total3: this.form.value.total3,
            totalt: this.form.value.totalt
        });
        localStorage.setItem("superficie_anteproyecto", JSON.stringify(this.rows));
    };
    Superficie_anteproyectoComponent.prototype.delete_superficie_anteproyecto = function (id) {
        for (var x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("superficie_anteproyecto", JSON.stringify(this.rows));
            }
        }
    };
    return Superficie_anteproyectoComponent;
}());
export { Superficie_anteproyectoComponent };
